/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { renderList } from "common/vue/render-list";
import "./StickersToolsTabs.scss";

export default function StickersToolsTabs({ artwork, slots, ...restProps }: any) {
  const tabs = [
    {
      label: "Background",
      icon: "tools-background",
      value: "background"
    },
    {
      label: "Border",
      value: "border"
    }
  ];

  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const [tab, setTab] = useState(tabs[0].value);

  function handleClick(item: any) {
    if (artwork.processingImage) return;
    setTab(item.value);
    const payload = {
      tab: item.value,
      page: "PDP",
      business_line: "Stickers",
      artwork_id: artwork.id,
      is_bg_removed: artwork.removeBackground
    };
    submitDtfEvent("sticker_tool_tab_change", payload);
  }

  return (
    <div {...restProps} className={cn("stickers-tools-tabs", restProps.className)}>
      <div className="stickers-tools-tabs__items">
        {renderList(tabs, item => (
          <button
            className={cn({
              "stickers-tools-tabs__item": true,
              "stickers-tools-tabs__item--active": item.value === tab
            })}
            key={item.value}
            type="button"
            onClick={e => {
              e.preventDefault();
              handleClick(item);
            }}
            data-testid="stickers-tools-tabs-button"
          >
            {item.icon ? (
              <UseSvg
                className="stickers-tools-tabs__icon"
                icon={item.icon}
                width="24"
                height="24"
                data-testid="stickers-tools-tabs-icon"
              />
            ) : (
              <span
                className={cn([
                  "stickers-tools-tabs__icon",
                  `stickers-tools-tabs__icon--${item.value}`
                ])}
              />
            )}{" "}
            {item.label}
          </button>
        ))}
      </div>
      {slots?.default?.({ tab })}
    </div>
  );
}
